<div class="webrtc-connection-window">
    <button class="close-btn" (click)="disconnect()">&times;</button>
    <div class="webrtc-window-container">
        <canvas
            #remoteCanvas
            class="webrtc-container"
            tabindex="0"
            (mousemove)="onMouseMove($event)"
            (mousedown)="onMouseDown($event)"
            (mouseup)="onMouseUp($event)"
            (wheel)="onWheel($event)"
            (keydown)="onKeyDown($event)"
            (keyup)="onKeyUp($event)"
            (contextmenu)="$event.preventDefault()"
        ></canvas>
        <div *ngIf="connectionError" class="connection-error">
            {{ connectionError }}
        </div>
    </div>
</div>

<p-toast></p-toast>
